import produce from "immer";
import {
  CHANGE_CALCULS_PAGE,
  CHANGE_CALCULS_SORT,
  DELETE_CALCUL,
  DELETE_CALCUL_FAILED,
  DELETE_CALCUL_SUCCESS,
  DUPLICATE_CALCUL_SUCCESS,
  GET_USER_CALCULS_FAILED,
  GET_USER_CALCULS_SUCCESS,
  LOAD_CALCUL_FAILED,
  LOAD_CALCUL_SUCCESS,
  LOAD_USER_CALCULS,
  CLEAR_CALCUL_OBJECT,
  REMOVE_REPORTS,
  UPDATE_CALCULS_LIMIT,
  SET_CALCUL_ARCHIVED_SUCCESS,
  SET_CALCUL_ARCHIVED_FAILED,
  RESTORE_ARCHIVED_CALCUL_SUCCESS,
  RESTORE_ARCHIVED_CALCUL_FAILED,
  CHANGE_CALCULS_SEARCH,
  UPDATE_CALCUL_ATTRIBUTES_SUCCESS,
  UPDATE_CALCUL_ATTRIBUTES_FAILED,
  MANAGE_CALCULS_BULK_SUCCESS,
  MANAGE_CALCULS_BULK_FAILED,
  UPDATE_CALCULS_FILTERS,
  CLOSE_CALCULS_FILTERS_SECTION,
  OPEN_CALCULS_FILTERS_SECTION,
  defaultCalculsFilters,
  UPGRADE_CALCUL_SUCCESS,
} from "../constants";
import { SORT_CALCUL_MODIFIED_AT_DESC } from "../../../common/constants/sort";
import {
  GENERATE_REPORTS_SUCCESS,
  SAVE_FDES_FORM_SUCCESS,
  UPDATE_CALCUL_SUCCESS,
} from "../../fdes/constants";
import {
  DEFAULT_PAGINATION_LIMIT,
  normalizePaginationLimit,
} from "../../../common/constants/pagination";

const initialState = {
  calculs: [],
  calcul: {},
  isLoading: false,
  sort: SORT_CALCUL_MODIFIED_AT_DESC,
  limit: DEFAULT_PAGINATION_LIMIT,
  currentPage: 1,
  total: 0,
  calculReports: {},
  search: "",
  isFilterSectionOpen: false,
  filters: defaultCalculsFilters,
};

const calculsReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case UPGRADE_CALCUL_SUCCESS:
      storeUpgradedCalcul(draft, action.payload);
      break;
    case LOAD_CALCUL_SUCCESS:
      storeCalcul(draft, action.payload);
      break;
    case LOAD_CALCUL_FAILED:
      draft.calcul = {};
      break;
    case GET_USER_CALCULS_SUCCESS:
      storeCalculs(draft, action.payload);
      break;
    case GET_USER_CALCULS_FAILED:
      draft.calculs = [];
      draft.total = 0;
      draft.isLoading = false;
      break;
    case CHANGE_CALCULS_SORT:
      draft.currentPage = 1;
      draft.sort = action.sort;
      draft.isLoading = true;
      break;
    case CHANGE_CALCULS_PAGE:
      draft.isLoading = true;
      draft.currentPage = action.page;
      break;
    case LOAD_USER_CALCULS:
      draft.isLoading = true;
      break;
    case DELETE_CALCUL:
      draft.isLoading = true;
      break;
    case DELETE_CALCUL_SUCCESS:
      draft.isLoading = false;
      draft.calculs = draft.calculs.filter(
        (calcul) => calcul._id !== action.payload._id,
      );
      break;
    case DELETE_CALCUL_FAILED:
      draft.isLoading = false;
      break;
    case DUPLICATE_CALCUL_SUCCESS:
      storeCalcul(draft, action.payload);
      draft.isLoading = false;
      break;
    case CLEAR_CALCUL_OBJECT:
      draft.calcul = {};
      draft.calculReports = {};
      break;
    case GENERATE_REPORTS_SUCCESS:
      storeFiles(draft, action.payload);
      draft.isLoading = false;
      break;
    case REMOVE_REPORTS:
      draft.calculReports = { createdAt: draft.calculReports?.createdAt };
      break;
    case UPDATE_CALCUL_SUCCESS:
      draft.calcul.updatedAt = action.payload.updatedAt;
      draft.calcul.options = action.payload.options;
      break;
    case UPDATE_CALCULS_LIMIT:
      draft.isLoading = true;
      draft.currentPage = 1;
      draft.limit = normalizePaginationLimit(action.limit);
      break;
    case SET_CALCUL_ARCHIVED_SUCCESS:
    case SET_CALCUL_ARCHIVED_FAILED:
    case RESTORE_ARCHIVED_CALCUL_SUCCESS:
    case RESTORE_ARCHIVED_CALCUL_FAILED:
    case UPDATE_CALCUL_ATTRIBUTES_FAILED:
    case MANAGE_CALCULS_BULK_SUCCESS:
    case MANAGE_CALCULS_BULK_FAILED:
      draft.isLoading = false;
      break;
    case CHANGE_CALCULS_SEARCH:
      draft.isLoading = true;
      draft.currentPage = 1;
      draft.search = action.search;
      break;
    case UPDATE_CALCUL_ATTRIBUTES_SUCCESS:
      updateCalculInCalculs(draft, action.payload);
      draft.isLoading = false;
      break;
    case UPDATE_CALCULS_FILTERS:
      draft.isLoading = true;
      draft.currentPage = 1;
      draft.filters = action.filters;
      break;
    case OPEN_CALCULS_FILTERS_SECTION:
      draft.isFilterSectionOpen = true;
      break;
    case CLOSE_CALCULS_FILTERS_SECTION:
      draft.isFilterSectionOpen = false;
      break;
    case SAVE_FDES_FORM_SUCCESS:
      {
        const unitLabel = extractUnitLabel(action.payload);
        if (unitLabel) {
          if (!draft.calcul) {
            draft.calcul = {};
          }
          if (!draft.calcul.metadata) {
            draft.calcul.metadata = {};
          }
          draft.calcul.metadata.unitLabel = unitLabel;
        }
      }
      break;
    default:
      return draft;
  }
});

function storeCalculs(draft, payload) {
  draft.calculs = payload.data;
  draft.total = payload.total;
  draft.isLoading = false;
}

function storeUpgradedCalcul(draft, payload) {
  draft.calculs = [
    ...draft.calculs.filter((x) => x._id !== payload._id),
    payload,
  ];
  draft.calcul = payload;
}

function storeCalcul(draft, payload) {
  const calculPayload = payload?.data || payload;

  draft.calcul = calculPayload;
  draft.calculReports = calculPayload?.reports;
}

function storeFiles(draft, reports) {
  draft.calculReports = reports;
}

function updateCalculInCalculs(draft, payload) {
  const index = draft.calculs.findIndex((calcul) => calcul._id === payload._id);
  if (index !== -1) {
    Object.assign(draft.calculs[index], payload);
  }
}

function extractUnitLabel(payload) {
  return payload?.metadata?.unitLabel || payload?.data?.metadata?.unitLabel;
}

export default calculsReducer;
